module.exports = __webpack_public_path__ + "static/media/Agente_in_info.2f5d48a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/Agente_in_info.svg
// module id = 1774
// module chunks = 0